const externalWalletProvider = window.ctsautoconf.EXTERNAL_WALLET_PROVIDER
const state = window.ctsautoconf.STATE

var providerEWbalances, providerEWbalancesCash, providerEWbalancesBonus, providerServiceName, geoComplyCustomField, customFieldKey, geocomplyPluginVersion, installerKey, refreshSession, logout
var installerURL = (process.env.NODE_ENV === 'production') ? 'ums.geocomply.com' : 'stg-ums.geocomply.net'

switch (state) {
  case 'NJ':
    installerKey = 'LW2BYMiQ3R'
    break
  case 'PA':
    installerKey = 'QnEkBJRFBy'
    break
  case 'WV':
    installerKey = 'izB796DMwa'
    break
  default:
    installerKey = 'LW2BYMiQ3R'
}

switch (externalWalletProvider) {
  case 'GAN':
    providerServiceName = 'ExternalWalletService'
    providerEWbalancesCash = 'CASH'
    providerEWbalancesBonus = 'CHANNEL_CREDIT'
    geoComplyCustomField = false
    customFieldKey = ''
    geocomplyPluginVersion = '3.1.1.3'
    refreshSession = true
    logout = true
    break
  case 'FD':
    providerServiceName = 'FanDuelWalletService'
    providerEWbalances = 'SportsbookPlayable'
    providerEWbalancesCash = 'SportsbookPlayableCash'
    providerEWbalancesBonus = 'SportsbookBonus'
    geoComplyCustomField = true
    customFieldKey = 'session_id'
    geocomplyPluginVersion = '3.1.1.3'
    refreshSession = true
    logout = true
    break
  case 'HALLEY':
    providerServiceName = 'ProbabilityService'
    providerEWbalances = 'SportsbookPlayable'
    providerEWbalancesCash = ''
    providerEWbalancesBonus = ''
    geoComplyCustomField = false
    geocomplyPluginVersion = '3.1.1.3'
    refreshSession = false
    logout = false
    break
}

export default {
  providerServiceName,
  balance: providerEWbalances,
  balanceCash: providerEWbalancesCash,
  balanceBonus: providerEWbalancesBonus,
  geoComplyCustomField,
  customFieldKey,
  geocomplyPluginVersion,
  installerKey,
  installerURL,
  refreshSession,
  logout
}



// WEBPACK FOOTER //
// ./src/config/externalWalletParams.js